var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OverviewActions',{attrs:{"type":"tickets","item-id":_vm.ticket.id,"info":"","take":"","disable-take":_vm.isTicketPending},on:{"onTake":_vm.takeTicket}})}
var staticRenderFns = []

export { render, staticRenderFns }